export const TEXT_ERRORS = {
    FETCH_TEXT_INFO_ERROR: "Error fetching text info:",
    ASSIGN_USER_ERROR: "Error assign user:",
    END_CONVERSATION_ERROR: "Error end conversation:",
    FETCH_USER_INFO_ERROR: "Error user info:",
    UPDATE_ASSIGNEE_ERROR: "Error updating assignee:",
    FETCH_TEXT_CONVERSATION_BY_ID_ERROR: "Error fetching text conversation by ID:",
    UPDATE_CARA_RESPONSE_CHAT_ERROR: "Error updating Cara response chat:",
    APPROVE_SEND_CHAT_ERROR: "Error approving and sending chat:",
};

export const TEXT_SUCCUSS = {
    ASSIGNEE_UPDATE: "Assignee updated successfully",
    END_CONVERSATION: "Conversation ended successfully",
};

export const TEXT_STRING = {
    END_CONVERSATION_DAILOG_HEADER: "Confirm End Conversation",
    ASSIGN_USER_DAILOG_HEADER: "Assign User",
    ASSIGN_ME: "Assign to me",
    ASSIGN_USER: "Assign",
    TEXT_SEARCH_CUSTOMER_PLACEHOLDER: "Search Customers or Campaigns",
    ASSIGN_TO_PLACEHOLDER: "Assigned To",
    REVIEW_PLACEHOLDER: "Review",
    STATUS_PLACEHOLDER: "Status",
    ASSIGN : "Assign",
    END_CONVERSATION: "End Conversation",
    APPROVE_RESPONSE_LABEL: "Approve Response",
    EDIT_CARA_RESPONSE_HEADER: "Edit Cara Response",
    EDIT_RESPONSE: "Edit Response",
    APPROVE_AND_SEND: "Approve & Send",
    SEND_TEXT: "Send Text",
    SEND_EMAIL: "Send Email",
};

export const TEXT_MESSAGE = {
    END_CONVERSATION_DAILOG_MESSAGE: "Are you sure you want to end the conversation with this customer?",
    ASSIGN_USER_VALIDATION_MESSAGE: "Please select a user or check 'Assign to me' option.",
    NO_TEXT_CONVERSATION: "No user texts found.",
};

export const TEXT_CONVERSATION_TABS = {
   CONVERSATION: "Conversation",
   PROFILE: "Profile",
   NOTES: "Notes",
   PAYMENT: "Payment",
   HISTORY: "History",
   CHATS: "Chats",
   CALLS: "Calls",
   EMAILS: "Emails",
};